<template>
  <v-container id="directions">
    <v-layout column>
      <v-flex class="display-2 text-xs-center my-5">Directions</v-flex>
      <v-divider insert></v-divider>
      <v-container lg4>
        <v-flex>
          <p class="subheading mt-3">
            Check back here to get detailed information on directions getting to
            and from the event.
          </p>
        </v-flex>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Directions',
};
</script>

<style scoped></style>
